"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var timeAgo = function timeAgo(time) {
  var units = [{
    name: 'second',
    limit: 60,
    in_seconds: 1
  }, {
    name: 'minute',
    limit: 3600,
    in_seconds: 60
  }, {
    name: 'hour',
    limit: 86400,
    in_seconds: 3600
  }, {
    name: 'day',
    limit: 604800,
    in_seconds: 86400
  }, {
    name: 'week',
    limit: 2629743,
    in_seconds: 604800
  }, {
    name: 'month',
    limit: 31556926,
    in_seconds: 2629743
  }, {
    name: 'year',
    limit: null,
    in_seconds: 31556926
  }];
  var diff = (new Date() - new Date(time)) / 1000;
  if (diff < 59) return 'now';
  var i = 0;
  var unit; // eslint-disable-next-line no-sequences

  while (unit = units[i++], unit) {
    if (diff < unit.limit || !unit.limit) {
      diff = Math.floor(diff / unit.in_seconds);
      return diff + ' ' + unit.name + (diff > 1 ? 's' : '') + ' ago';
    }
  }
};

var _default = timeAgo;
exports.default = _default;